import React from "react";

const HawkeyeIcon = () => {
	return (
		<svg viewBox="74.82 -0.23 550.37 560.24">
  <path d="m139.12 266.18h395.06v18.375h-395.06z"/>
  <path d="m139.12 266.18h395.06v18.375h-395.06z"/>
  <path d="m534.19 275.36 18.375-18.375 55.125 18.375-55.125 18.375z"/>
  <path d="m551.25 300.04-24.586-24.676 24.586-24.59 73.938 24.586zm-8.75-24.676 12.074 12.074 36.312-12.074-36.312-12.074z"/>
  <path d="m203.44 275.36-128.62 18.375v-36.75z"/>
  <path d="m203.44 275.36-128.62 18.375v-36.75z"/>
  <path d="m175.79 256.99h-36.227l-48.562-7 29.75-29.75z"/>
  <path d="m175.79 293.74-55.039 36.75-29.75-29.75 48.562-7z"/>
  <path d="m488.25 242.11v14.875h-93.539v-26.25h-35v-56.438h81.812s-6.8242 67.812 46.727 67.812z"/>
  <path d="m394.71 293.74h93.539v27.562h-93.539z"/>
  <path d="m425.07 165.11h-66.324c-31.414-67.812-65.012-102.29-91-119.79v-36.574h-36.75v19.863c-2.8711-0.70312-5.8008-1.1406-8.75-1.3125v-9.2734l-4.8984-7.6992v-0.003906c23.625-12.344 51.418-13.938 76.297-4.375 49.789 17.5 93.977 70.965 131.43 159.16z"/>
  <path d="m383.6 330.49h80.676l-23.102 22.836c-39.637 110.43-89.688 177.54-148.84 199.32-12.727 4.7969-26.207 7.2852-39.812 7.3516-15.453 0.23438-30.734-3.2812-44.535-10.238l4.5508-8.0508v-8.75c6.2031-0.36328 12.312-1.6914 18.109-3.9375v22.227h36.75v-43.75c30.539-23.801 68.773-70.438 101.59-162.14l0.4375-1.3984z"/>
  <path d="m240.19 18.199h18.375v238.88h-18.375z"/>
  <path d="m240.19 293.74h18.375v248.06h-18.375z"/>
</svg>
	);
};

export default HawkeyeIcon;